export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems[0]))

      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.mc         = json.mc
      this.sc         = json.sc
      this.mcc        = json.mcc
      this.columns    = json.columns

      this.sundries   = json.sundries
      this.keys       = json.keys
      this.filters    = json.filters
      
      
      this.gmx_tableCoordinates('x', this.columns.ITRs, 0)
      this.mc.width = this.columns.ITRs[this.columns.ITRs.length-1].ex

      this.gmx_tableCoordinates('x', this.columns.Punch, 0)
      this.sc.width = this.columns.Punch[this.columns.Punch.length-1].ex

    },



    set_Gradients() {

    },
  },
}